module.exports = __webpack_public_path__ + "assets/img/32_561.5e158b78.jpg";